module.exports = __webpack_public_path__ + "img/506.3af06841.jpg";